/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, January 2020
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { PersonalDataContainer } from '../../containers';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import { DecisionContainer } from '../../containers';
import _ from 'lodash';

import v from './validators';
import fetch from '../../core/fetch/fetch.server';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const InfoTypeDict = {
  roadNumber: {
    label: 'Numer drogi:',
    editable: true,
  },
  street: {
    label: 'Ulica',
    editable: true,
  },
  deviceName: {
    label: 'Nazwa umieszczonego urządzenia:',
    editable: true,
  },
  town: {
    label: 'Miejscowość:',
    editable: true,
  },
  dateStart: {
    label: 'Naliczenie opłaty od dnia:',
    editable: true,
  },
  dateEnd: {
    label: 'Naliczenie opłaty do dnia:',
    editable: true,
  },
  totalDays: {
    label: 'Łącznie dni:',
    editable: false,
  },
};

const AreaDict = {
  linia: {
    label: 'linia (kablowa, światłowodowa) [m2]:',
    editable: true,
  },
  siec: {
    label: 'sieć (gazowa, ciepłownicza, kanalizacyjna, wodociągowa) [m2]:',
    editable: true,
  },
  zlacze: {
    label: 'złącze (kablowe, gazowe) [m2]:',
    editable: true,
  },
  rury: {
    label: 'rury ochronne [m2]:',
    editable: true,
  },
  inne: {
    label: 'Inne [m2]:',
    editable: true,
  },
  total: {
    label: 'Razem [m2]:',
    editable: false,
  },
};

const DecisionDict = {
  decisionNumber: {
    label: 'Numer decyzji:',
    editable: true,
  },
  decisionDate: {
    label: 'Data wydania decyzji:',
    editable: true,
  },
};


class NaliczenieOplatyRocznej extends React.Component {
  state = {
    info: {
      roadNumber: null,
      street: null,
      deviceName: null,
      town: null,
      dateStart: null,
      dateEnd: null,
      totalDays: '0',
      linia: 0,
      siec: 0,
      zlacze: 0,
      rury: 0,
      inne: 0,
      total: 0,
      decisionNumber: null,
      decisionDate: null,
    },
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
  };

  validators = {
    roadNumber: [v.NotNull],
    street: [],
    deviceName: [v.NotNull],
    town: [v.NotNull],
    dateStart: [v.NotNull, v.CheckDate],
    dateEnd: [v.NotNull, v.CheckDate],
    linia: [v.NotNull, v.isNumber],
    siec: [v.NotNull, v.isNumber],
    zlacze: [v.NotNull, v.isNumber],
    rury: [v.NotNull, v.isNumber],
    inne: [v.NotNull, v.isNumber],
    decisionNumber: [v.NotNull],
    decisionDate: [v.NotNull, v.CheckDate],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });
  }

  onHide = () => this.setState({ showError: false });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name, this.calculateFields),
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  calculateFields = () => {
    const m2 = parseFloat(this.state.info.linia) +
              parseFloat(this.state.info.siec) +
              parseFloat(this.state.info.rury) +
              parseFloat(this.state.info.inne) +
              parseFloat(this.state.info.zlacze);
    let timeDifferenceInDays = 0;
    if (this.state.info.dateStart.length === 10 && this.state.info.dateEnd.length === 10) {
      const dateStart = this.state.info.dateStart.split('-');
      const dateEnd = this.state.info.dateEnd.split('-');
      const date1 = new Date(dateStart[2], dateStart[1], dateStart[0]);
      const date2 = new Date(dateEnd[2], dateEnd[1], dateEnd[0]);
      const date1Unixtime = parseInt(date1.getTime() / 1000);
      const date2Unixtime = parseInt(date2.getTime() / 1000);
      const timeDifference = date2Unixtime - date1Unixtime;
      timeDifferenceInDays = Math.round(timeDifference / 60 / 60 / 24);
    }
    this.setState(
      {
        info: {
          ...this.state.info,
          totalDays: timeDifferenceInDays,
          total: m2,
        },
      });
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        roadNumber: '111',
        street: 'testowa',
        deviceName: 'urządzenie testowe',
        town: 'miejscowość testowa',
        dateStart: '27-01-2020',
        dateEnd: '27-07-2020',
        linia: 10,
        siec: 10,
        zlacze: 10,
        rury: 10,
        inne: 5.5,
        decisionNumber: 'Numer testowy',
        decisionDate: '17-01-2020' },
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: {},
          selectedParcels: {},
          info: this.state.info,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
        })
        .then(resp => {
          window.location.href = `${this.nextStep}${resp.jobId}`;
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />
        <DecisionContainer
          title={'1. Informacje'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={InfoTypeDict}
          onChange={e => this.onChange(e, 'info')}
        />
        <DecisionContainer
          title={'2. Powierzchnia pasa drogowego zajęta przez rzut poziomy urządzeń infrastruktury technicznej niezwiązanych z potrzebami zarządzania drogami lub potrzebami ruchu drogowego'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={AreaDict}
          onChange={e => this.onChange(e, 'info')}
        />
        <DecisionContainer
          title={'3. Informacje o decyzji, na podstawie której umieszczono urządzenie'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={DecisionDict}
          onChange={e => this.onChange(e, 'info')}
        />
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ progress: 0 }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

NaliczenieOplatyRocznej.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(NaliczenieOplatyRocznej),
);



// WEBPACK FOOTER //
// src/routes/eservices/NaliczenieOplatyRocznej.js